import React from "react"
import PropTypes from "prop-types"

import getBackground from "./getBackground"

import * as S from "./styled"

const PostItem = ({
  slug,
  category,
  date,
  fullwidth,
  /*   image, */
  id,
  timeToRead,
  title,
  description,
}) => (
  <S.PostItemLink
    to={slug}
    key={id}
    fullwidth={fullwidth}
    /* image={image ? image.childImageSharp.fluid.src : ""} */
  >
    <S.PostItemWrapper>
      <S.PostItemInfo>
        <S.PostItemTitle>{title}</S.PostItemTitle>
        <S.PostItemCategory background={getBackground(category)}>
          {category}
        </S.PostItemCategory>
        <S.PostItemDate>
          {date} | {timeToRead} min de leitura
        </S.PostItemDate>
        <S.PostItemDescription>{description}</S.PostItemDescription>
      </S.PostItemInfo>
    </S.PostItemWrapper>
  </S.PostItemLink>
)

PostItem.propTypes = {
  slug: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  fullwidth: PropTypes.bool,
  timeToRead: PropTypes.number,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
}

export default PostItem
